"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarginAccountSummaryContainer = void 0;
var _reactRedux = require("react-redux");
var _MarginAccountSummaryComponent = _interopRequireDefault(require("./MarginAccountSummaryComponent"));
var _selectors = require("../../../redux/margin/selectors");
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
var _actions = require("../../../redux/margin/actions");
var _marginHelper = require("../../../helpers/marginHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var marginAccount = (0, _selectors.marginAccountSelector)(state);
  var baseAsset = (0, _productsSelectors.baseNotionalProductSelector)(state);
  var summary = state.margin.accountInfo;
  var riskLevel = (0, _marginHelper.getRiskLevel)(summary.RiskLevel, summary.InMarginCall, summary.InLiquidation);
  return {
    marginAccount: marginAccount,
    summary: summary,
    baseAsset: baseAsset,
    riskLevel: riskLevel
  };
};
var MarginAccountSummaryContainer = exports.MarginAccountSummaryContainer = (0, _reactRedux.connect)(mapStateToProps, {
  getMarginAccountInfo: _actions.getMarginAccountInfo
})(_MarginAccountSummaryComponent["default"]);